// extracted by mini-css-extract-plugin
export default {"searchItemWrapper":"styles_searchItemWrapper__vqzn4","contentWrapper":"styles_contentWrapper__8L+v-"};